import { useFeatureValue } from "@growthbook/growthbook-react";
import { GrowthbookFeatures } from "components/growthbook/growthbook.types";
import { ClassRating } from "constants/rate-classes";
import { ModalSource } from "hooks/use-rate-class/use-rate-class.types";
import React from "react";
import trackEvent from "services/mixpanel/mixpanel";
import { getEventBasedOnRating } from "services/mixpanel/user-feedback-events";
import RateClassRatings from "../rate-class-ratings/rate-class-ratings";
import { IUserFeedbackFeatureValue } from "../rate-classes.types";

import {
  RateClassCardContainer,
  RateClassCardHeader
} from "./rate-class-card.styles";

import { IRateClassCardProps } from "./rate-class-card.types";

const RateClassCard: React.FC<IRateClassCardProps> = ({
  data,
  onRatingClick
}) => {
  const handleRatingClick = (rating?: ClassRating) => {
    onRatingClick({
      ...data,
      rating,
      modalSource: ModalSource.FEEDBACK_SECTION
    });

    if (rating) {
      trackEvent({
        eventName: getEventBasedOnRating(rating),
        payload: {
          classID: data.liveClass.id,
          subject: data.subject.name,
          source: "live class feedback section"
        }
      });
    }
  };

  const featureValue = useFeatureValue(GrowthbookFeatures.UserFeedback, null);

  if (featureValue) {
    return (
      <RateClassCardContainer onClick={() => handleRatingClick()}>
        <RateClassCardHeader>
          {
            (featureValue as IUserFeedbackFeatureValue).user_feedback_var_key
              .header_bottom_sheet
          }{" "}
          <br /> {data.subject?.name}
        </RateClassCardHeader>
        <RateClassRatings
          selectedValue={data.previousState?.rating || null}
          onRatingClick={handleRatingClick}
        />
      </RateClassCardContainer>
    );
  }
  return <></>;
};

export default RateClassCard;
